import {NfMessage, NfMessageType} from "../NfMessage";
import {NfComponentGlobalMessage} from "../NfComponentGlobalMessage";
var nextRequestId = 1;

/**
 * Wiadomość, gdy chcemy sprawdzić tylko czy rezerwacja jest możliwa
 */
export class CheckBookingPossible extends NfComponentGlobalMessage {
    public requestId: number = nextRequestId++;
    public constructor(sourceComponentId: number|MessageEvent<CheckBookingPossible>) {
        super(NfMessageType.CheckBookingPossible, !NfMessage.isMessageEvent(sourceComponentId));
        if(NfMessage.isMessageEvent(sourceComponentId)) {
            Object.assign(this, sourceComponentId.data);
        } else {
            this.sourceComponentId = sourceComponentId;
        }
    }
}
NfMessage.creationCallbacks[NfMessageType.CheckBookingPossible] = (event) => {
    return new CheckBookingPossible(event);
}
